import React, {useEffect, useState, useRef, useCallback} from 'react';
import {isMobile} from "react-device-detect";
import {useLocation, useNavigate} from "react-router-dom";

import {NavLink as RouterLink} from "react-router-dom";

import {signOut, getAuth} from "firebase/auth";

import {ThemeProvider} from '@mui/material/styles';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';

import {isAdmin} from 'ultra/helpers/auth';
import {revertPath} from 'ultra/helpers/route';
import {getClientCity} from 'ultra/configs/general';

import AdaptiveDialog from '../../../../Components/Adaptive/Dialog';

import {USER_ACTIONS} from '../../../Profile/Reducers/user';
import {NODE_ACTIONS} from '../../Reducers/node';

import {useToasterStore} from '../../../../Stores/toster';
import {useNavigationStore} from '../../../../Stores/navigation';
import {useNotifyStore} from '../../../../Stores/notify';
import {useBackdropPreloaderStore} from '../../../../Stores/backdropPreloader';
import {useIncomeStore} from '../../../../Stores/income';

import {useGlobalCustomContext} from '../../../../Helpers/context';
import {getNodeContent} from '../../../../Helpers/content';

import BannerCarousel from '../../../../Components/BannerCarousel';
import Notify from '../../../../Components/Notify';
import PreloaderBackdrop from '../../../../Components/Preloaders/PreloaderBackdrop';

import NodePopups from '../../Components/NodePopups';
import UserPic from '../../Components/UserPic';
import UserNotify from '../../Components/UserNotify';

import TelegramNotifications from '../../../Profile/Components/TelegramNotifications';
import Edit from '../../../Profile/Pages/Edit';
import SignIn from '../../../Profile/Pages/SignIn'

import Footer from '../../Widgets/Footer';

import theme from '../../../../mui';

import {getUserDetails} from '../../../Profile/Helpers/user';

import './index.scss'

const AppLayout = (props) => {
  const {configs} = props;

  const location = useLocation();
  const navigate = useNavigate();

  const {contentLoading} = useNavigationStore();
  const {nodeState, userState, nodeDispatch, userDispatch} = useGlobalCustomContext();
  const {showBackdropPreloader, hideBackdropPreloader} = useBackdropPreloaderStore();
  const {showNotify} = useNotifyStore();
  const {showError} = useToasterStore();
  const {income, setIncome} = useIncomeStore();

  const [maintainanceMode, setMaintainanceMode] = useState(configs?.layout?.maintainanceMode || false);

  useEffect(() => {
    fetchUserData()
      .catch(getUserDataHandlerError);
  }, [])

  useEffect(() => {
    if (userState?.userRefreshStarted) {
      // prevent double tap
      userDispatch({type: USER_ACTIONS.USER_REFRESH_STOP});

      fetchUserData()
        .catch(getUserDataHandlerError);
    }
  }, [userState?.userRefreshStarted])

  function getUserDataHandlerError(err) {
    console.error(err);
  }

  const fetchUserData = useCallback(async () => {
    // if user undefined it means authorisation in progress
    // or was logout
    userDispatch({type: USER_ACTIONS.USER_UPDATE_IN_PROGRESS});
    getUserDetails()
      .promise
      .then(user => {
        if (user) {
          userDispatch({type: USER_ACTIONS.USER_UPDATE, data: {user}});

          let additionalNotifications = 0;
          if (user._not_checked) additionalNotifications++;
          if (user.emailNotVerified) additionalNotifications++;

          setIncome(user.income + additionalNotifications);
        } else {
          userDispatch({type: USER_ACTIONS.USER_REMOVE});
        }
      })
      .catch((err) => {
        userDispatch({type: USER_ACTIONS.USER_REMOVE});

        if (userState?.user && err.tokenExpired) {
          showError({snackbarMessage: 'Ви авторизовались понад 7 днів тому. Будь ласка, авторизуйтесь повторно'});
        }
        else {
          if (err.status === 401) {
            console.error(err)

            // if 401 returned, empty object setup. it means non authorised user
            userDispatch({type: USER_ACTIONS.USER_REMOVE});
          }
        }
      })
  })

  useEffect(() => {
    if (configs?.layout?.maintainanceMode) setMaintainanceMode(!isAdmin(userState?.user))
  }, [userState?.user, configs])

  // const [defaultNotificationsConfig, setDefaultNotificationsConfig] = useState({
  //   all: true,
  //   events: {},
  //   system: true
  // });

  // const [telegram] = useState(getTelegramUser());

  const handleProfileEditClose = () => {
    userDispatch({type: USER_ACTIONS.PROFILE_EDIT_CLOSE});
  };

  const handleTelegramNotifyEditClose = () => {
    userDispatch({type: USER_ACTIONS.TG_NOTIFY_EDIT_CLOSE});
  }

  const onNotificationsSubmit = () => {
    userDispatch({type: USER_ACTIONS.USER_REFRESH_START});
    userDispatch({type: USER_ACTIONS.TG_NOTIFY_EDIT_CLOSE});
    showNotify({text: "Конфігурація успішно збережена"});
  }

  const handleTelegramPopupClose = () => {
    userDispatch({type: USER_ACTIONS.LOGIN_TELEGRAM_LINK_CLOSE})
  }

  const handleLoginClose = () => {
    userDispatch({type: USER_ACTIONS.LOGIN_CLOSE});
  };

  const goToTelegram = () => {
    window.open('https://t.me/MiyProstirBot?startapp=reload')
  }

  const onLoginSuccess = () => {
    if (mode === 'verifyEmail') return;

    userDispatch({type: USER_ACTIONS.LOGIN_CLOSE});
    navigate(location.pathname + location.search);
    userDispatch({type: USER_ACTIONS.USER_REFRESH_START});
  }

  const url = new URL(window.location.href);
  const mode = url.searchParams.get('mode');

  // const isRootPage = window.location.pathname === '/'
  let hasBanner = configs?.layout?.mainCarousell && configs?.layout?.mainCarousell?.banners && configs.layout.mainCarousell.banners?.length > 0
  if (configs?.layout?.mainCarousell?.hide && configs?.layout?.mainCarousell?.hide.length > 0 && configs?.layout?.mainCarousell?.hide.includes(revertPath(location.pathname))) hasBanner = false
  if (configs?.layout?.mainCarousell?.show && configs?.layout?.mainCarousell?.show.length > 0 && !configs?.layout?.mainCarousell?.show.includes(revertPath(location.pathname))) hasBanner = false

  return <ThemeProvider theme={theme}>
    <div className='contentWrap'>
        <Notify />
        <PreloaderBackdrop />

        <div className='pageTop'>
          <div className='subheader'>
            <div className='subheaderWrap'>
              <RouterLink className='logo' to="/">
                <img className='logoImg' src="/img/logo.png" />
                <span className='brand'>
                  ПРОСТІР
                </span>
                <span className='beta'>beta</span>
              </RouterLink>
            </div>

            <UserNotify configs={configs} />
            <UserPic showCity/>
          </div>
          
          {hasBanner && !maintainanceMode && <div className='MainBannerCarousellWrap'>
            <Collapse in={!contentLoading}>
              <BannerCarousel
                className="MainBannerCarousell"
                animation="slide"
                autoPlay={false}
                data={configs?.layout?.mainCarousell}
              />
            </Collapse>
          </div>}

        </div>

        <div className='AppWrap'>
          {configs && props.children}
        </div>

        {!isMobile && <Footer />}

        {/* POPUPS */}
        <NodePopups />

        <AdaptiveDialog open={Boolean(userState?.telegramEditPopupOpen)} onClose={handleTelegramNotifyEditClose} title="Сповіщення">
            <TelegramNotifications config={userState?.user?.telegram_profile?.notify} onSubmit={onNotificationsSubmit}/>
        </AdaptiveDialog>

        <AdaptiveDialog open={Boolean(userState?.profileEditPopupOpen)} onClose={handleProfileEditClose} title="Мій Простір">
          <Edit user={userState?.user} onClose={handleProfileEditClose} />
        </AdaptiveDialog>

        <AdaptiveDialog open={Boolean(userState?.loginPopupOpen)} onClose={handleLoginClose} hideClose title={mode === 'verifyEmail' ? "Підтвердження email" : "Мій Простір"}>
          {userState?.loginPopupHeader && <div className='FormTitle'>{userState.loginPopupHeader}</div>}
          {mode === 'verifyEmail' && <p className='verifyEmailText'>Для підтвердження вашого email, введіть ваш email та пароль</p>}
          <SignIn onSuccess={onLoginSuccess} mode={mode} />
          {isMobile && mode !== 'verifyEmail' && <Footer />}
        </AdaptiveDialog>

        <AdaptiveDialog open={Boolean(userState?.loginTelegramLinkPopupOpen)} onClose={handleTelegramPopupClose} title="Підтвердження email">
            <div className="TelegramEmailApproveText">
                Ваш email <i>{userState?.loginTelegramLinkPopupOpen}</i> успішно підтверджено 
            </div>
        
            <Button
                fullWidth
                variant="contained"
                onClick={goToTelegram}
            >
                Перейти в бот
            </Button>
        </AdaptiveDialog>
    </div>
    </ThemeProvider>
}

export default AppLayout
